var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupActionsLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4378 14.0699V8.09993C18.4378 3.62646 14.6602 0 10.0003 0C5.34046 0 1.5629 3.62646 1.5629 8.09993V14.0699C-1.10002 18.0885 -0.291065 23.3739 3.46346 26.4874C7.21798 29.6008 12.7827 29.6008 16.5372 26.4874C20.2917 23.3739 21.1007 18.0885 18.4378 14.0699ZM11.2499 20.0698V22.7998C11.2499 23.4626 10.6902 23.9998 9.99988 23.9998C9.30953 23.9998 8.74989 23.4626 8.74989 22.7998V20.0674C7.76998 19.5243 7.29223 18.4171 7.58508 17.3678C7.87794 16.3186 8.86837 15.589 9.99988 15.589C11.1314 15.589 12.1218 16.3186 12.4147 17.3678C12.7075 18.4171 12.2298 19.5243 11.2499 20.0674V20.0698ZM15.018 10.5693C15.2017 10.4599 15.3135 10.2671 15.3135 10.0595V8.09994C15.3135 5.28331 12.935 2.99998 10.001 2.99998C7.06702 2.99998 4.68856 5.28331 4.68856 8.09994V10.0595C4.68856 10.2671 4.80031 10.4599 4.98403 10.5693C5.16774 10.6788 5.39732 10.6893 5.59105 10.5971C8.36871 9.27081 11.6333 9.27081 14.411 10.5971C14.6047 10.6893 14.8343 10.6788 15.018 10.5693Z",
    fill: "#0D54BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupActionsLocked);
export default __webpack_public_path__ + "static/media/group_actions_locked.4a19bd5fb046aa93b093b1af3db3b9db.svg";
export { ForwardRef as ReactComponent };